import {Component} from '@angular/core';
import {ModalController, NavController, NavParams, ViewController} from 'ionic-angular';

import {AlertService} from '../../../providers/alert-service';
import {CargoService} from '../../../providers/cargo-service';
import {GestaoPcaService} from "../../../providers/gestao-pca-service";
import {ModulosController} from "../../modulos/modulos-controller";
import {PessoalService} from "../../../providers/pessoal-service";
import {UsuarioService} from "../../../providers/usuario-service";

@Component({
  selector: 'page-modal-cargo',
  templateUrl: 'modal-cargo.html',
  providers: [
    CargoService,
    PessoalService
  ]
})
export class ModalCargoPage extends ModulosController {

  //objetoComboCargo: any = [];
  objeto: any;
  titulo: any;
  moduloPca: any;

  isLoading = true;
  //listaCargos: any;

  constructor(private viewCtrl: ViewController,
              public navCtrl: NavController,
              public navParams: NavParams,
              public CargoService: CargoService,
              public modalCtrl: ModalController,
              public pessoalService: PessoalService,
              public alertService: AlertService,
              public usuarioService: UsuarioService,
              public gestaoPcaService: GestaoPcaService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    //this.carregarModal();
    this.titulo = this.navParams.get('param1');
    this.objeto = this.navParams.get('param2');
    this.gestaoPcaService.obterModuloPcaPorModuloPorPCA(11, this.PCAAtiva.id).subscribe(data => {
      this.isLoading = false;
      this.moduloPca = data;
    }, error => {
      this.isLoading = false;
      console.log("ERRO ao carregar ModuloPCA");
    });

  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  salvarCargo() {
    this.objeto.idModuloPca = this.moduloPca.idModuloPca;
    this.CargoService.salvarNovoCargo(this.objeto).subscribe(data => {
      this.alertService.mostraAlerta("", "Cargo salvo com sucesso!");
      this.viewCtrl.dismiss();
    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("Ocorreu um erro ao salvar", error.mensagem);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-cargo/modal-cargo.ts